import {Component} from '@angular/core';
import {RuleListComponent} from '../../components/rule-list/rule-list.component';

@Component({
  selector: 'app-page-rule-list',
  imports: [
    RuleListComponent
  ],
  templateUrl: './page-rule-list.component.html',
  styleUrl: './page-rule-list.component.scss'
})
export class PageRuleListComponent {
}
